package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RecentActivitiesResponse(
    val count: Int = 0,
    val activities: List<RecentActivitySummary> = emptyList()
)

@Serializable
data class RecentActivitySummary(
    val id: String = "",
    @SerialName("table_name")
    val tableName: String = "",
    val action: String = "",
    @SerialName("record_id")
    val recordId: String = "",
    val description: String = "",
    val timestamp: String = "",
    @SerialName("user_id")
    val userId: String? = null,
    @SerialName("actor_login")
    val actorLogin: String? = null
)
